


export interface Player {
  id?: number;
  avatar: string;
  name: string;
}

export const emptyPlayer: Player = {
  id: undefined,
  avatar: '',
  name: '',
};

export const defaultPlayer: Player = {
  id: undefined,
  avatar:
    'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
  name: '',
};

export const defaultMatch: Partial<Match> = {
  parentId: -1,
  posLeft: { player: emptyPlayer, posIndex: -1 },
  posRight: { player: emptyPlayer, posIndex: -1 },
  disabled: true,
};

export interface Position {
  id: number;
  player?: Player;
  playerIndex?: number;

  posIndex: number;
  depth: number;
  matchIndex?: number;
  votes: number;
  nextPos?: number;
  leftPos?: number;
  rightPos?: number;
  disabled: boolean;
}

export interface Match {
  parentId: number;
  posLeft: Position | Partial<Position>;
  posRight: Position | Partial<Position>;
  votes: boolean;
  disabled: boolean;
}

export interface Tournament {
  id: number;
  name: string;
  size: number;
  tournamentType: string | undefined;
  status: 'started' | 'ended' | 'created' | 'draft' | 'start' | '' | 'demo';
  currentRound: number;
  totalRounds: number;
  matchTime: number;
  positions: Position[];
  endMatch: number;
  views: number;
  champion?: Position;
}


export const exampleTournament: Tournament = {
  id: 0,
  name: 'Torneio do Poder',
  tournamentType: 'elimination',
  size: 8,
  status: 'demo',
  currentRound: 1,
  totalRounds: 3,
  matchTime: 300,
  positions: [
    {
      id: 1,
      posIndex: 0,
      player: {
        id: 1,
        avatar: 'https://pm1.aminoapps.com/6476/07629815ac241a4eb0974d9df4c9b67c7e6d634a_128.jpg',
        name: 'jorgen von strangle',
      },
      depth: 3,
      votes: 20,
      nextPos: 3,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 2,
      posIndex: 1,
      player: {
        id: 2,
        avatar: 'https://i.pinimg.com/280x280_RS/11/80/fb/1180fbee659b84b0a1d573a70b38d9a9.jpg',
        name: 'Shrek',
      },
      depth: 3,
      votes: 31,
      nextPos: 3,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 4,
      posIndex: 2,
      player: {
        id: 3,
        avatar: 'https://i.pinimg.com/280x280_RS/ec/09/6b/ec096b70b70811fa882422ac610b5fba.jpg',
        name: 'Thanos',
      },
      depth: 3,
      votes: 19,
      nextPos: 14,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 5,
      posIndex: 3,
      player: {
        id: 4,
        avatar: 'https://styles.redditmedia.com/t5_4xzmi8/styles/communityIcon_8vs4n4kap7j71.png',
        name: 'Larry the lobster',
      },
      depth: 3,
      votes: 28,
      nextPos: 14,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 6,
      posIndex: 4,
      player: {
        id: 5,
        avatar: 'https://pbs.twimg.com/profile_images/624200140136407040/-wTYxKrf_400x400.jpg',
        name: 'johnny Bravo',
      },
      depth: 3,
      votes: 54,
      nextPos: 15,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 7,
      posIndex: 5,
      player: {
        id: 6,
        avatar: 'https://64.media.tumblr.com/avatar_3ba39b290513_128.png',
        name: 'Kronk',
      },
      depth: 3,
      votes: 71,
      nextPos: 15,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 8,
      posIndex: 6,
      player: {
        id: 7,
        avatar: 'https://ih1.redbubble.net/image.2064595518.1969/flat,64x64,075,t.jpg',
        name: 'Dave Barbarian',
      },
      depth: 3,
      votes: 61,
      nextPos: 16,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 9,
      posIndex: 7,
      player: {
        id: 8,
        avatar: 'https://i.stack.imgur.com/qsOLt.jpg?s=256&g=1',
        name: 'Infraggable Krunk',
      },
      depth: 3,
      votes: 53,
      nextPos: 16,
      leftPos: undefined,
      rightPos: undefined,
      disabled: true,
    },
    {
      id: 3,
      posIndex: 8,
      player: {
        id: 2,
        avatar: 'https://i.pinimg.com/280x280_RS/11/80/fb/1180fbee659b84b0a1d573a70b38d9a9.jpg',
        name: 'Shrek',
      },
      depth: 2,
      votes: 0,
      nextPos: 17,
      leftPos: 1,
      rightPos: 2,
      disabled: true,
    },
    {
      id: 14,
      posIndex: 9,
      player: {
        id: 4,
        avatar: 'https://styles.redditmedia.com/t5_4xzmi8/styles/communityIcon_8vs4n4kap7j71.png',
        name: 'Larry the lobster',
      },
      depth: 2,
      votes: 0,
      nextPos: 17,
      leftPos: 4,
      rightPos: 5,
      disabled: true,
    },
    {
      id: 15,
      posIndex: 10,
      player: {
        id: 6,
        avatar: 'https://64.media.tumblr.com/avatar_3ba39b290513_128.png',
        name: 'Kronk',
      },
      depth: 2,
      votes: 0,
      nextPos: 18,
      leftPos: 6,
      rightPos: 7,
      disabled: true,
    },
    {
      id: 16,
      posIndex: 11,
      player: {
        id: 7,
        avatar: 'https://ih1.redbubble.net/image.2064595518.1969/flat,64x64,075,t.jpg',
        name: 'Dave Barbarian',
      },
      depth: 2,
      votes: 0,
      nextPos: 18,
      leftPos: 8,
      rightPos: 9,
      disabled: true,
    },
    {
      id: 17,
      posIndex: 12,
      player: {
        avatar:
          'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
        name: '',
      },
      depth: 1,
      votes: 0,
      nextPos: 19,
      leftPos: 3,
      rightPos: 14,
      disabled: true,
    },
    {
      id: 18,
      posIndex: 13,
      player: {
        avatar:
          'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
        name: '',
      },
      depth: 1,
      votes: 0,
      nextPos: 19,
      leftPos: 15,
      rightPos: 16,
      disabled: true,
    },
    {
      id: 19,
      posIndex: 14,
      player: {
        avatar:
          'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
        name: '',
      },
      depth: 0,
      votes: 0,
      nextPos: undefined,
      leftPos: 17,
      rightPos: 18,
      disabled: true,
    },
  ],
  endMatch: 0,
  views: 0,
};

export const emptyTournament: Partial<Tournament> = {
  tournamentType: 'elimination',
  size: 8,
  status: 'draft',
  matchTime: 300,
  positions: [],
};